module.exports = __webpack_public_path__ + "static/media/image_22.bf4b0476.png";